import React from 'react';
import RateOutFitCardStackHOC from './RateOutFitCardStackHOC'
import Branding from '../templates/Branding'
import moment from 'moment'
const _ = require('lodash')


class RateTheLookHOC extends React.Component {

  render() {
    if(this.props.data.loading){
      return null
    }
    return (
        <Branding>
          <RateOutFitCardStackHOC cards={this.props.data.allOutfits} />
        </Branding>
      )
  }
}

export default RateTheLookHOC



// WEBPACK FOOTER //
// ./src/components/RateTheLookHOC.js